import Image from 'next/image';
import topupdated from '../../../../public/topupatednew.webp';
import clutch from '../../../../public/clutupdatednew.webp';
import batch from '../../../../public/credit_batch.webp';
import dungs from '../../../../public/dungsnew.webp';
import esomar from '../../../../public/ESOMAR_member_RGB-17.webp';
import iso9001 from '../../../../public/iso-9001-updated.webp';
import iso27001 from '../../../../public/iso-27001-updated.webp';

export default function CredibilityAndCert() {
  return (
    <>
      <div className="flex flex-col gap-y-2 justify-center items-center">
        <div>
          <Image
            src={batch}
            className="img-fluid"
            alt="Reward Batch"
            title="Reward Batch"
            sizes="100vw"
            style={{
              width: '40px',
              height: 'auto',
            }}
          />
        </div>
        <div className="flex flex-row gap-2 justify-between">
          <div className="text-center">
            <Image
              src={dungs}
              className="img-fluid"
              alt="Top Market Research Agency"
              title="Top Market Research Agency"
              sizes="100vw"
              style={{
                width: '125px',
                height: 'auto',
              }}
            />
            <p className="text-white text-xs">860519526</p>
          </div>
          <div>
            <div className="flex flex-row gap-3 justify-between">
              <div>
                <div className="bg-white">
                  <Image
                    src={iso9001}
                    className="img-fluid px-5 py-1 w-[130px] h-[45px] sm:h-[67]"
                    alt="Top Market Research Agency"
                    title="Top Market Research Agency"
                    sizes="100vw"
                  />
                </div>
                <p className="text-white text-xs text-center">9001:2015</p>
              </div>
              <div>
                <div className=" bg-white">
                  <Image
                    src={iso27001}
                    className="img-fluid px-5 py-1 w-[130px] h-[45px] sm:h-[67]"
                    alt="Top Market Research Agency"
                    title="Top Market Research Agency"
                    sizes="100vw"
                  />
                </div>
                <p className="text-white text-xs text-center">27001:2022</p>
              </div>
              <div>
                <Image
                  src={topupdated}
                  className="img-fluid w-[130px] h-[45px] sm:h-[67]"
                  alt="Top Market Research Agency"
                  title="Top Market Research Agency"
                  sizes="100vw"
                />
              </div>
            </div>
            <div className="flex flex-row gap-3 mt-3 -ms-2 sm:-ms-5 lg:ms-0 justify-start">
              <div>
                <Image
                  src={esomar}
                  className="img-fluid w-[80px] sm:w-[110px] h-[45px] sm:h-[67]"
                  alt="Top Market Research Agency"
                  title="Top Market Research Agency"
                  sizes="100vw"
                />
              </div>
              <div>
                <Image
                  src={clutch}
                  className="img-fluid w-[80px] sm:w-[110px] h-[45px] sm:h-[67]"
                  alt="Clutch"
                  title="Clutch"
                  sizes="100vw"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
